import React from 'react';
import { PluginSlot } from '@openedx/frontend-plugin-framework';

const DashboardModalSlot = () => (
  <PluginSlot id="org.openedx.frontend.learner_dashboard.dashboard_modal.v1" />
);

export default DashboardModalSlot;
